import { request } from './instance';
import { SEARCH_PATH } from '../endpoints';
import { SearchDto, SearchRequest } from '@shared';

export default class SearchService {
  static getCollection = (params: SearchRequest) => {
    return request<SearchDto>({
      url: SEARCH_PATH,
      params,
      method: 'get',
    });
  };
}
